import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { IconPrimitive } from '#pplx/frontend/aether/primitives/IconPrimitive/index.js';
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { MentionIconRendererContext } from '#pplx/frontend/composer-sdk/lexical/MentionIconRendererContext.js';
import { MENTION_NODE_CHIP_CLASS_NAME, MENTION_NODE_CHIP_EMOJI_CLASS_NAME, MENTION_NODE_CHIP_ICON_CLASS_NAME, MENTION_NODE_CHIP_TEXT_CLASS_NAME, MENTION_NODE_ICON_SIZE_PX, getMentionNodeDisplayText, } from '#pplx/frontend/composer-sdk/lexical/nodes/MentionNodeShared.js';
import classNames from 'classnames';
import React, { useContext } from 'react';
// TODO: migrate to use Aether <Accessory /> component
export const MentionNodeVisual = React.memo(function MentionNodeVisual({ icon, renderIcon, iconClassName, emojiClassName, }) {
    const mentionIconRenderer = useContext(MentionIconRendererContext);
    if (!icon) {
        return null;
    }
    switch (icon.type) {
        case 'emoji':
            return (_jsx("span", { className: classNames('inline-block select-none', emojiClassName), children: icon.char }));
        case 'icon': {
            const IconComponent = icon.icon;
            return (_jsx(IconPrimitive, { icon: IconComponent, size: MENTION_NODE_ICON_SIZE_PX, className: classNames('inline-block shrink-0 rounded-xs', iconClassName) }));
        }
        case 'image':
            return (_jsx("i", { className: classNames('inline-block shrink-0 select-none rounded-xs bg-cover bg-center bg-no-repeat', iconClassName), style: {
                    backgroundImage: `url(${icon.url})`,
                    fontSize: '0.78rem',
                } }));
        case 'source': {
            const renderedIcon = (renderIcon ?? mentionIconRenderer)?.(icon);
            return renderedIcon ? (_jsx("span", { className: classNames('inline-flex shrink-0 items-center justify-center overflow-hidden [&>*]:size-full [&>*>*]:size-full', iconClassName), children: renderedIcon })) : null;
        }
        default:
            return assertUnreachableValue(icon);
    }
});
export const MentionNodeTextContent = React.memo(function MentionNodeTextContent({ className, textClassName, iconClassName, emojiClassName, text, localizedName, mentionVariant, prefixWithSlash, icon, renderIcon, color, size, weight, truncate, variant, tooltipText, inlineAlignment = 'baseline', }) {
    const displayText = getMentionNodeDisplayText({
        text,
        localizedName,
        mentionVariant,
        prefixWithSlash,
    });
    return (_jsx(Tooltip, { content: tooltipText ?? '', disabled: !tooltipText, children: _jsxs("span", { className: classNames('inline-flex min-w-0', {
                'max-w-[168px]': truncate === 'small',
                'max-w-[208px]': truncate === 'medium',
                'max-w-[250px]': truncate === 'large',
                'items-baseline align-baseline': inlineAlignment === 'baseline',
                'items-center align-middle': inlineAlignment === 'middle',
            }, className), spellCheck: false, children: [_jsx(MentionNodeVisual, { icon: icon, renderIcon: renderIcon, iconClassName: iconClassName, emojiClassName: emojiClassName }), _jsx(TextPrimitive, { className: classNames('inline-block min-w-0 truncate', textClassName), color: color, size: size, weight: weight, as: "span", variant: variant, children: displayText })] }) }));
});
export const MentionNodeChipContent = React.memo(function MentionNodeChipContent({ size = 'base', ...props }) {
    return (_jsx(MentionNodeTextContent, { ...props, className: MENTION_NODE_CHIP_CLASS_NAME, textClassName: MENTION_NODE_CHIP_TEXT_CLASS_NAME, iconClassName: MENTION_NODE_CHIP_ICON_CLASS_NAME, emojiClassName: MENTION_NODE_CHIP_EMOJI_CLASS_NAME, color: "default", size: size === 'small' ? 'sm' : 'base', weight: "semibold", truncate: "large" }));
});
//# sourceMappingURL=MentionNodeContent.js.map